
import './App.css';
import Mainpage from './components/mainpage';
function App() {
  return (
    <div>
      <Mainpage/>
    </div>
  );
}

export default App;
